import * as Sentry from "@sentry/react";
import { useEffect, type ReactNode } from "react";
import { useAuthStore } from "../stores/auth.store";
import * as authApi from "../api/auth.api";

export function AuthProvider({ children }: { children: ReactNode }) {
  const isLoading = useAuthStore((s) => s.isLoading);
  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    let cancelled = false;
    async function checkSession() {
      try {
        const data = await authApi.getSession();
        if (!cancelled) {
          setUser(data.user);
          if (data.user) {
            Sentry.setUser({ id: data.user.id, email: data.user.email });
          }
        }
      } catch {
        if (!cancelled) setUser(null);
      }
    }
    checkSession();
    return () => { cancelled = true; };
  }, [setUser]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-gray-900" />
      </div>
    );
  }

  return <>{children}</>;
}
